import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import DateTimePicker from 'react-datetime-picker';
import { ShipmentCreateModel } from '../apiModels/shipmentCreateModel';
import { logError } from "../utilities";
import { createShipment } from '../api/adminApi';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import ShipmentEditForm from './ShipmentEditForm';

export default function ShipmentCreateModal(props: { show: boolean, setShow: (show: boolean) => void, callback?: () => void }) {
    const notifyUserOfError = (err: string) => toast(err, { type: 'error' });
    const notifyUserOfSuccess = (msg: string) => toast(msg, { type: 'success' });

    const [trackingNumber, setTrackingNumber] = useState<string>('');
    const [memo, setMemo] = useState<string>('');
    const [initialStatusDescription, setInitialStatusDescription] = useState<string>('');
    const [initialStatusLocation, setInitialStatusLocation] = useState<string | undefined>('');
    const [initialStatusTime, setInitialStatusTime] = useState<Date | null>(null);
    const [isSubmittingForm, setIsSubmittingForm] = useState<boolean>(false);

    const resetForm = () => {
        setTrackingNumber('');
        setMemo('');
        setInitialStatusDescription('');
        setInitialStatusLocation('');
        setInitialStatusTime(new Date());
    };

    const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsSubmittingForm(true);

        try {
            if (trackingNumber === undefined || trackingNumber === null || trackingNumber === '') {
                notifyUserOfError('Tracking number is required.');
            }

            else if (trackingNumber.length > 20) {
                notifyUserOfError('Tracking number must be less than or equal to 20 characters.');
            }

            else {
                const shipment: ShipmentCreateModel = {
                    trackingNumber: trackingNumber,
                    memo: memo,
                    initialStatusDescription: initialStatusDescription,
                    initialStatusLocation: !initialStatusLocation || initialStatusLocation == '' ? null : initialStatusLocation,
                    initialStatusTime: initialStatusTime,
                };

                await createShipment(shipment);

                notifyUserOfSuccess('Shipment created successfully.');
                setIsSubmittingForm(false);
                resetForm();
                props.setShow(false);

                if (props.callback) {
                    props.callback();
                }
            }
        }
        catch (error: any) {
            if (error instanceof Error) {
                notifyUserOfError(error.message);
            }

            logError(error);

            setIsSubmittingForm(false);
        }
        finally {
            // It is important to always return false to prevent the form from submitting.
            return false;
        }
    };

    return (
        <>
            <Modal className='modal-lg' show={props.show} onHide={() => props.setShow(false)}>
                <form onSubmit={submitForm}>
                    <Modal.Header closeButton>
                        <Modal.Title>Create New Shipment</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='row'>
                            <h3 className='col-12'>Shipment</h3>
                        </div>
                        <ShipmentEditForm
                            trackingNumber={trackingNumber}
                            setTrackingNumber={setTrackingNumber}
                            memo={memo}
                            setMemo={setMemo}
                            isCreate={true}
                            initialStatusDescription={initialStatusDescription}
                            setInitialStatusDescription={setInitialStatusDescription}
                            initialStatusLocation={initialStatusLocation}
                            setInitialStatusLocation={setInitialStatusLocation}
                            initialStatusTime={initialStatusTime}
                            setInitialStatusTime={setInitialStatusTime}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            className='btn btn-primary'
                            type="submit"
                            disabled={isSubmittingForm}>
                            {isSubmittingForm ? "Creating" : "Create"}
                        </button>
                        <button
                            className='btn btn-default'
                            onClick={() => props.setShow(false)}>
                            Cancel
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
            <ToastContainer />
        </>
    );
};

export const ButtonLoadingSpinner = () => {
    return (
        <div className="spinner-border spinner-border-sm text-default" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
};